module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Leo_Ana.7a010832.jpg";